<script setup lang="ts"></script>

<template>
    <div class="py-4">
        <div class="border-b border-gray-300" />
    </div>
</template>
